import { render, staticRenderFns } from "./logDetails.vue?vue&type=template&id=161dcf8f&scoped=true"
import script from "./logDetails.vue?vue&type=script&lang=js"
export * from "./logDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161dcf8f",
  null
  
)

export default component.exports